<template>
  <section>


    <v-layout align-center justify-center>
      <v-flex xs12>
        <transition name="fade" mode="out-in">
          <v-card :key="activeQuestion.section != 'WELCOME'">



            <transition name="fade" mode="out-in">
              <v-card-text :key="isIntro" class="pa-0" :style="[isIntro ? {backgroundColor: backgroundColor} : {backgroundColor: 'white'}]">

                <v-toolbar flat dark :style="[isIntro ? {backgroundColor: backgroundColor} : {backgroundColor: 'black'}]">
                  <v-spacer></v-spacer>
                  <v-toolbar-title >
                    <span :class="textColor" class="bebas-2" v-if="!complete && activeQuestion.type != 'intro'">
                      {{title}}
                    </span>
                    <span class="bebas-2" style="color: #5872B7" v-if="complete">Results</span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                
                <v-container v-show="activeQuestion.section != 'WELCOME'" class="pa-0 pt-2" grid-list-md text-xs-center>
                  <v-layout row wrap>
                    <v-flex offset-md1 sm12 md10 >
                      <summary-card v-if="complete" :back="previousQuestion" :scores="scores" :assessment="assessment" :name="name" :questions="questions" />
                      <div class="main-holder" v-if="!complete && activeQuestion.section != 'WELCOME'">
                        <img style="display: none;" src="@/assets/intro.jpg">
                        <question-card class="main" :key="activeQuestion.section" :question="activeQuestion" v-bind="{answer}"/>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>

                <div style="overflow: hidden; " v-show="activeQuestion.section == 'WELCOME'">
                  <v-layout style="height: 100%" row wrap>
                    <v-flex xs12 sm6 class="fit ok">
                      <transition name="fade" mode="out-in">
                        <!-- <img :key="showImage" v-if="showImage == 1" class="mobile" src="@/assets/intro.jpg"> -->
                        <img :key="showImage" v-if="showImage == 1" class="mobile" src="@/assets/intro.jpg">
                        <img :key="showImage" v-if="showImage == 2" class="mobile" src="@/assets/intro2.jpg">
                        <img :key="showImage" v-if="showImage == 3" class="mobile" src="@/assets/intro3.jpg">
                        <img :key="showImage" v-if="showImage == 4" class="mobile" src="@/assets/intro4.jpg">
                        <img :key="showImage" v-if="showImage == 5" class="mobile" src="@/assets/intro5.jpg">
                        

                        
                        <img style="display: none;" src="@/assets/intro.jpg">
                        <img style="display: none;" src="@/assets/intro2.jpg">
                        <img style="display: none;" src="@/assets/intro3.jpg">
                        <img style="display: none;" src="@/assets/intro4.jpg">
                        <img style="display: none;" src="@/assets/intro5.jpg">
                      </transition>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <div class="intro-holder">
                  
                        <div class="main">
                          <div :class="textColor" style="text-align: center;" class="bebas-1 title-bar mt-1 mb-1">Hydrafacial Skin Health Assessment</div>
                          <hr style="border-color: #9069ad;" class="mx-3 mt-1 mb-3 horiz mobile-hide"/>
                          <table class="instructions">
                            <tr>
                              <td>
                                <span style="padding-left:10px; padding-right: 2px;" class="badge bebas-0 mr-3">1</span>
                              </td>
                              <td class="pr-3" >
                                <span class="text-container" style="font-size: 15px" >We'll get started with some basic lifestyle questions.</span>
                              </td> 
                            </tr>
                            <tr class="pb-4">
                              <td>
                                <span style="padding-left:10px;" class="badge bebas-0 mr-3">2</span>
                              </td>
                              <td class="pr-3">
                                <span class="text-container" style="font-size: 15px" >Then, we’ll go a bit deeper and talk about your skin goals and needs.</span>
                              </td> 
                            </tr>
                            <tr>
                              <td>
                                <span style="padding-left:10px;" class="badge bebas-0 mr-3">3</span>
                              </td>
                              <td class="pr-3">
                                <span class="text-container" style="font-size: 15px" >And finally, we’ll use the info you provide to develop a personalized skin health regimen just for you – including recommendations for customizing your next HydraFacial experience.</span>
                              </td> 
                            </tr>
               
                          </table>
                          <p class="text-xs-center pt-2">
                            <v-btn outline small v-if="showNext" style="height: 55px;" :class="textColor" class="bebas-1 px-4 square mobile-hide" flat @click="nextQuestion()" dark>
                              <v-spacer></v-spacer>
                              {{btnText}}
                            </v-btn>
                            <v-btn outline small v-if="showNext" style="height: 40px;" :class="textColor" class="bebas-0 px-4 square desktop-hide" flat @click="nextQuestion()" dark>
                              <v-spacer></v-spacer>
                              {{btnText}}
                            </v-btn>
                          </p>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card-text>
            
            </transition>

            <transition name="fade" mode="out-in">
              <v-card-actions class="pa-0" :key="isIntro" v-if="activeQuestion.section !== 'WELCOME' && !complete" :style="[isIntro ? {backgroundColor: backgroundColor} : {backgroundColor: 'white'}]">
                <v-container class="pa-0" grid-list-md text-xs-center>
                  <v-layout row wrap>
                    <v-flex offset-md1 sm12 md10>

                      <v-btn v-if="questionNumber != 0" style="height: 50px; float: left; color: #black;" @click="previousQuestion()" class="bebas-1 pl-0" small flat light>
                        <v-icon style="transform: rotate(180deg);" dark class="pr-1">play_arrow</v-icon>
                        Back
                      </v-btn>
                      <!-- <v-spacer></v-spacer> -->
                      <v-btn small v-if="showNext" style="height: 50px; float: right;" :class="textColor" class="bebas-1 pr-1" flat @click="nextQuestion()" dark>
                        <v-spacer></v-spacer>
                        {{btnText}}
                        <v-icon dark >play_arrow</v-icon>
                      </v-btn>
                      <!-- <v-spacer v-show="questionNumber == 0"></v-spacer> -->
                    </v-flex>
                  </v-layout>

                </v-container>
              </v-card-actions>
            </transition>
          
            <v-progress-linear class="mb-0" v-if="activeQuestion.section != 'WELCOME' && !complete" style="margin-top:1px;" :color="backgroundColor" :height="25" v-model="pctComplete"></v-progress-linear>
          </v-card>
        </transition>

        <v-layout class="desktop-hide" row wrap style="100%; padding-top: 8px;">
          <v-flex xs4 text-xs-left style="padding-left: 8px;">
            <v-icon 
              @click="social('email')"
              style="padding-bottom:3px;"
              :size="20"
              :color="'#FFFFFF'">
              fas fa-envelope
            </v-icon>
            <div style="color: white;">
              Email Us
            </div>
          </v-flex>

          <v-flex xs4 text-xs-center>
            <img style="height: 45px;" src="@/assets/info.png">
          </v-flex>

          <v-flex xs4 text-xs-right>
            <div>
              <v-icon 
                @click="social('facebook')"
                class="pr-2 pl-2"
                style="padding-bottom:3px;"
                :size="17"
                :color="'#FFFFFF'">
                fab fa-facebook-f
              </v-icon>
              <v-icon
                @click="social('instagram')"
                class="pr-2 pl-2"
                :size="22"
                :color="'#FFFFFF'">
                fab fa-instagram
              </v-icon>
              <v-icon
                @click="social('twitter')"
                class="pl-2 pr-2"
                :size="22"
                :color="'#FFFFFF'">
                fab fa-twitter
              </v-icon>
            </div>
            <div style="color: white;" class="pr-2">
              Follow Us
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      
      
    </v-layout>

    
    <transition name="fade" mode="out-in">
      <div v-if="showCompute"  style="position: absolute; top:0; left:0; width:100%; height: calc(100vh - 52px); background-color: rgba(0, 0, 0, 0.8); z-index: 1; text-align: center">
        <img class="center-image" src="@/assets/HF-loader.gif">
      </div>
    </transition>
  </section>
</template>

<script>
import db from '@/db';
import QuestionCard from './QuestionCard';
import SummaryCard from './SummaryCard';
export default {
  name: 'assessment',
  components: {
    'question-card': QuestionCard,
    'summary-card': SummaryCard
  },
  data() {
    return {
      showImage: 1,
      beginning: true,
      showCompute: false,
      assessment: {
        assessmentId: this.newGuid(),
        date: new Date(),
        social: {
          email: '',
          emailSubscribe: true,
          facebook: false,
          twitter: false,
          gotPersonalized: false,
          gotAesthetician: false,
        },
        answers:{

        },
        triggers:{
          
        }
      },
      complete: false,
      activeQuestion: {
        options: [],
        order: 1,
        questionId: 1,
        section: 'WELCOME',
        subSection: '',
        text: '',
        timesAnswered: 0,
        type: 'begin'
      },
      questionNumber: 0,
      questions: [{
        options: [],
        order: 1,
        questionId: 1,
        section: 'WELCOME',
        subSection: '',
        text: '',
        timesAnswered: 0,
        type: 'begin'
      }],
      questionOptions: [],
      scores: {
        hydrationScore: 0,
        poresScore: 0,
        toneScore: 0,
        triggers: []
      }
    };
  },
  computed: {
    isIntro: function (){
      if (this.activeQuestion.type == 'intro'){
        return true;
      }else{
        return false;
      }
    },
    name: function (){
      if (this.questions && this.questions[2].answer){
        return this.questions[2].answer;
      }else{
        return 'no name provided';
      }
    },
    location: function (){
      if (this.questions && this.questions[4].answer){
        return this.questions[4].answer;
      }else{
        return 'no location provided';
      }
    },
    title: function(){
      return this.activeQuestion.section.split(':').pop();
    },
    textColor: function() {
      if (this.activeQuestion.section == 'SECTION A: INTRO') {
        return 'intro-text';
      }
      if (this.activeQuestion.section == 'SECTION B: BASICS') {
        if (this.activeQuestion.type == 'intro'){
          return 'white-text';
        }else{
          return 'basics-text';
        }
      }
      if (this.activeQuestion.section == 'SECTION C: HABITS') {
        if (this.activeQuestion.type == 'intro'){
          return 'white-text';
        }else{
          return 'habits-text';
        }
      }
      if (this.activeQuestion.section == 'SECTION D: SKIN HEALTH') {
        if (this.activeQuestion.type == 'intro'){
          return 'white-text';
        }else{
          return 'testing-text';
        }
      }
      if (this.activeQuestion.section == 'SECTION E: RESULTS') {
        if (this.activeQuestion.type == 'intro'){
          return 'white-text';
        }else{
          return 'results-text';
        }
      }
      else{
        return 'intro-text';
      }
    },
    backgroundColor: function() {
      if (this.activeQuestion.section == 'SECTION A: INTRO') {
        return '#9069AD';
      }
      if (this.activeQuestion.section == 'SECTION B: BASICS') {
        return '#C560A4';
      }
      if (this.activeQuestion.section == 'SECTION C: HABITS') {
        return '#F0887F';
      }
      if (this.activeQuestion.section == 'SECTION D: SKIN HEALTH') {
        return '#3DABC5';
      }
      else{
        return '#9069AD';
      }
    },
    showNext: function() {
      if (!this.complete) {
        if (this.activeQuestion.type == 'intro' || this.activeQuestion.type == 'begin' || this.activeQuestion.type == 'number') {
          return true;
        }
        if (Array.isArray(this.activeQuestion.answer)) {
          if (this.activeQuestion.answer.length > 0) {
            return true;
          } else {
            return false;
          }
        } else {
          if (this.activeQuestion.answer) {
            return true;
          } else {
            return false;
          }
        }
      }
      else{
        return null;
      }
    },
    pctComplete: function() {
      return (
        (this.questionNumber / (parseInt(this.questions.length) - 1)) * 100
      );
    },
    btnText: function() {
      if (this.questionNumber == 0) {
        return 'Start Assessment';
      } else {
        return 'Next';
      }
    },
    overallScore: function() {
      return (
        this.scores.hydrationScore +
        this.scores.poresScore +
        this.scores.toneScore
      );
    }
  },
  methods: {
    social: function(type) {
      if (type == 'email'){
        window.open('mailto:marketing@hydrafacial.com'); 
      }
      else if (type == 'facebook'){
        window.open('https://www.facebook.com/hydrafacial', '_blank'); 
      }
      else if (type == 'instagram'){
        window.open('https://www.instagram.com/hydrafacial', '_blank'); 
      }
      else if (type == 'twitter'){
        window.open('https://twitter.com/hydrafacial', '_blank'); 
      }
    },
    imageLoop: function (){
      for(var i = 0;i < 1005; i++){
        let k = i;
        setTimeout(()=>{
          if (this.showImage == 5){
            this.showImage = 1;
          }else{
            this.showImage++;
          }
        }, 5000 * (k + 1));
      }
    },
    nextQuestion: function() {
      if (this.activeQuestion.answer){
        if (this.activeQuestion.answer.text){
          this.$gtm.trackEvent({
            event: 'AssessmentStep',
            'question': this.activeQuestion.text,
            'answer': this.activeQuestion.answer.text,
            'progress': this.pctComplete
          });
        } else {
          this.$gtm.trackEvent({
            event: 'AssessmentStep',
            'question': this.activeQuestion.text,
            'answer': this.activeQuestion.answer,
            'progress': this.pctComplete
          });
        }
      }

      let oldQuestion = this.questionNumber;
      this.questionNumber++;

      if (this.questions[this.questionNumber]) {
        this.activeQuestion = this.questions[this.questionNumber];
      } else {
        this.showCompute = true;

        setTimeout(() => { 
          this.showCompute = false;
          this.complete = true;

          //WRITE ANSWERS TO DB

          this.questions.map(q => {
            if (q.answer && q.answer.id){

              var optionDocRef = db.collection('questionOptions').doc(q.answer.id);

              return db.runTransaction(function(transaction) {
                return transaction.get(optionDocRef).then(function(oDoc) {
                  if (!oDoc.exists) {
                    throw 'Document does not exist!';
                  }

                  var newCount = oDoc.data().timesAnswered + 1;
                  transaction.update(optionDocRef, { timesAnswered: newCount });
                });
              }).then(function() {
                // console.log('Transaction successfully committed!');
              }).catch(function(error) {
                // console.log('Transaction failed: ', error);
              });
            }
          });
        
          // WRITE TOTAL SCORES
          db.collection('scores')
            .doc(this.newGuid())
            .set({
              name: this.questions[2].answer,
              overallScore: this.scores.hydrationScore + this.scores.poresScore + this.scores.toneScore,
              hydrationScore: this.scores.hydrationScore,
              poresScore: this.scores.poresScore,
              toneScore: this.scores.toneScore,
              location: this.questions[5].answer,
              date: new Date()
            })
            .then(() => {
              // console.log('Score written successfully');
            })
            .catch(function(error) {
              // alert('error');
              console.error('Error writing score: ', error);
            });


        }, 3700);
       
      }

      this.scores.hydrationScore = 0;
      this.scores.poresScore = 0;
      this.scores.toneScore = 0;
      this.scores.triggers = [];
      this.$nextTick(() => {
        this.questions.forEach(q => {
          if (q.answer) {
            if (q.answer.trigger1) {
              if (!this.scores.triggers.includes(q.answer.trigger1)) {
                this.scores.triggers.push(q.answer.trigger1);
              }
            }
            if (q.answer.trigger2) {
              if (!this.scores.triggers.includes(q.answer.trigger2)) {
                this.scores.triggers.push(q.answer.trigger2);
              }
            }
            if (q.answer.trigger3) {
              if (!this.scores.triggers.includes(q.answer.trigger3)) {
                this.scores.triggers.push(q.answer.trigger3);
              }
            }
            if (q.subSection == 'SUBSECTION: HYDRATION	') {
              if (q.answer.points) {
                this.scores.hydrationScore += parseInt(q.answer.points);
              }
            }
            if (q.subSection == 'SUBSECTION: CONGESTION	') {
              if (q.answer.points) {
                this.scores.poresScore += parseInt(q.answer.points);
              }
            }
            if (q.subSection == 'SUBSECTION: TONE + TEXTURE') {
              if (q.answer.points) {
                this.scores.toneScore += parseInt(q.answer.points);
              }
            }
          }
        });
      });
      if (oldQuestion != 0){
        var questionDocRef = db.collection('question').doc(this.questions[oldQuestion].id);

        return db.runTransaction(function(transaction) {
          return transaction.get(questionDocRef).then(function(qDoc) {
            if (!qDoc.exists) {
              throw 'Document does not exist!';
            }

            var newCount = qDoc.data().timesAnswered + 1;
            transaction.update(questionDocRef, { timesAnswered: newCount });
          });
        }).then(function() {
        }).catch(function(error) {
          // console.log('Transaction failed: ', error);
        });
      }
    },
    newGuid: function() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    previousQuestion: function() {
      this.complete = false;
      this.questionNumber--;
      if (this.questions[this.questionNumber]) {
        this.$gtm.trackEvent({
          event: 'AssessmentStep',
          'question': this.activeQuestion.text,
          'answer': 'Back',
          'progress': this.pctComplete
        });
        this.activeQuestion = this.questions[this.questionNumber];
      } else {
        this.complete = true;
      }
    },
    answer: function(answer1, answer2) {
      this.nextQuestion();
    }
  },
  created() {
    this.imageLoop();
    this.assessmentId = this.newGuid();
    this.$gtm.trackEvent({
      event: 'AssessmentStart',
      'id': this.assessmentId
    });
    var startTime = new Date().getTime();
    var questionsProcessed = 0;
    db.collection('question')
      .orderBy('section')
      .orderBy('order')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          
          let qId = doc.id;
          let qDoc = doc.data();
          qDoc.id = qId;
          this.questions.push(qDoc);
          questionsProcessed++;
          if (questionsProcessed === querySnapshot.docs.length) {
            var optionsProcessed = 0;
            db.collection('questionOptions')
              .orderBy('order')
              .get()
              .then(querySnapshot => {
                querySnapshot.forEach(doc => {
                  let id = doc.id;
                  let ok = doc.data();
                  ok.id = id;
                  this.questionOptions.push(ok);
                  optionsProcessed++;
                  if (optionsProcessed === querySnapshot.docs.length) {
                    this.questions.forEach(question => {
                      question.options = [];
                      var optionsCombined = 0;
                      this.questionOptions.forEach(option => {
                        optionsCombined++;
                        if (question.questionId == option.questionId) {
                          question.options.push(option);
                        }
                        // if (optionsCombined == this.questionOptions.length) {
                        //   // this.activeQuestion = this.questions[0];
                        //   console.log(
                        //     'Questions call: ' +
                        //       (new Date().getTime() - startTime) / 1000 +
                        //       ' seconds'
                        //   );
                        // }
                      });
                    });
                  }
                });
              });
          }
        });
        // console.log(this.questions);
      });
  }
};
</script>

<style>

.futura-0{
  font-family: futura_pt_light;
  font-size: 25px !important;
}

.bebas-0{
  font-family: bebas_neuebook;
  font-size: 25px !important;
}

.bebas-1{
  font-family: bebas_neuebook;
  font-size: 34px !important;
}

.bebas-2{
  font-family: bebas_neuebook;
  font-size: 45px !important;
}

.bebas-3{
  font-family: bebas_neuebook;
  font-size: 56px !important;
}

table,
th,
td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: 1px solid black;
  border-collapse: collapse;
}
.v-toolbar__content {
  padding-left: 0px !important;
}

.intro-text {
  color: #9069ad !important;
}

.white-text{
  color: white !important;
}

.basics-text {
  color: #c560a4 !important;
}

.habits-text {
  color: #f0887f !important;
}

.testing-text {
  color: #3dabc5 !important;
}

.results-text {
  color: #5872b7 !important;
}
.text-container{
  font-size: 17px;
}
.right-social{
  position: absolute; right: 0px; bottom: 0px;
}
.left-social{
  position: absolute;
  bottom: 0px;
}
 .center-social{
    position: absolute;
    width: 100vw;
    bottom: 0px;

  }
.badge{
  /* background-color: #9069ad !important;
  color: white;
  display: inline-block;
  width: 40px;
  border-radius: 20px;
  text-align: center; */
  color: #9069ad !important;
}
table{
  /* margin-left: 20px; */
  max-width: 510px;
  margin-left: auto; 
  margin-right: auto;
  border: none;
}
td {
  border: none;
  padding-top:10px;
  padding-bottom:10px;
}
.fit{
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    height:500px;
}
.fit img{
    flex-shrink: 0;
    min-width: 100%;
    max-height: 800px;
    /* min-height:100%; */
}
.stupid{
  margin-top: 14px;
}
.square{
  border-radius: 0px !important;
}

.main{
  margin: auto;
  width: 100%;
}

.main-holder{
  min-width: 100% !important;
  height: 400px;
  display: grid;
}

.intro-holder{
  min-width: 100% !important;
  height: 100%;
  display: grid;
}

.container.grid-list-md .layout:only-child{
  margin: 0px !important;
}




@media (max-width: 600px) {
  .mobile {
    height: 175px;
    object-fit:cover;
    object-position: 50% 50%; /* default value: image is centered*/
    object-position: 0 0;
  }
  .mobile-hide{
    display: none !important;
  }
  .ok{
    max-height: 175px;
  }
  .bebas-1{
    font-size: 28px !important;
  }
  .spacerr{
    display: none;
  }
  .left-social{
    position: unset;

  }
   .center-social{
    position: unset;

  }
  .right-social{
    position: unset;

  }
}

@media (min-width: 600px) {
  .desktop-hide{
    display: none !important;
  }

}



@media (min-width: 1080px){
  .title-bar{
    font-size: 45px !important;
  }

}

@media (min-width: 809px){
  .title-bar{
    padding-bottom: 20px !important;
    /* font-size: 45px !important; */
  }

  .instructions {
    margin-bottom:20px !important;
    margin-top:30px !important;
  }

}


.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-active {
  opacity: 0
}

.center-image{
  padding-top: 245px;
}

</style>
